var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L0 5L8 10L14.5 5.9375V8.13378C14.2011 8.30669 14 8.62986 14 9V15H16V9C16 8.62986 15.7989 8.30669 15.5 8.13378V5.5C15.5 5.44063 15.4897 5.38367 15.4707 5.33084L16 5L8 0Z",
    fill: "#FF6624"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12V8.875L8 12L13 8.875V12C12.6667 13 11.2 15.2 8 16C4.8 15.2 3.33333 13 3 12Z",
    fill: "#FF6624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEducation);
export default __webpack_public_path__ + "static/media/icon-education.e8a4e79353c50bbfa9923b68773dca2c.svg";
export { ForwardRef as ReactComponent };